<template>
  <base-material-card
    color="indigo"
    icon="mdi-text-box-multiple-outline"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="visitNotesSearch"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-3" />
    <shop-machine-visit-dialog
      :show="showEditDialog"
      :shop-machine-visit-id="shopMachineVisitId"
      :method="shopMachineVisitDialogMethod"
      @change-edit-dialog="changeEditDialog"
    />
    <v-data-table
      :headers="localizationNoteHeaders"
      :items="visitNoteItems"
      :search.sync="visitNotesSearch"
      :sort-by="['visitDate']"
      :sort-desc="[true]"
      :loading="visitNotesLoading"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <v-spacer />
        </v-toolbar>
      </template>
      <template v-slot:item.visitDate="{ item }">
        {{ item.visitDate | formatLongDate }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="success"
          class="px-1 ml-1"
          fab
          x-small
        >
          <v-icon @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t('notes') }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-textarea
                  v-model="item.notes"
                  readonly
                />
              </v-container>
            </v-card-text>
          </v-card>
        </td>
      </template>>
    </v-data-table>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </base-material-card>
</template>

<script>
  import axios from 'axios'
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const shopMachineVisitNotesRespository = repositoryFactory.get('shopMachineVisitNotes')

  export default {
    name: 'Notes',
    components: {
      shopMachineVisitDialog: () => import('./ShopMachineVisitDialog'),
    },
    mixins: [filters],
    data: () => ({
      visitNoteItems: [],
      visitNotesItems: [],
      visitNotesSearch: undefined,
      visitNotesLoading: false,
      showErrorMessage: false,
      errorMessage: '',
      showEditDialog: false,
      shopMachine: {
        shop: {
        },
        machine: {

        },
      },
      shopMachineVisitId: null,
      shopMachineVisitDialogMethod: 'add',
    }),
    computed: {
      title: {
        get () {
          return this.$t('notes')
        },
      },
      localizationNoteHeaders () {
        return [
          {
            text: this.$t('tables.shopMachineVisitNote.visitDate'),
            value: 'visitDate',
          },
          {
            text: this.$t('tables.shopMachineVisitNote.userName'),
            value: 'createdByUserUserName',
          },
          {
            text: this.$t('tables.shopMachineVisitNote.notes'),
            value: 'notes',
            sortable: false,
          },
        ]
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        var self = this
        var id = self.$route.params.id
        self.visitNotesLoading = true
        axios.all([shopMachineVisitNotesRespository.get(id)])
          .then(axios.spread((shopMachineVisitoperationResponse) => {
            self.visitNotesLoading = false
            self.visitNoteItems = shopMachineVisitoperationResponse.data.data
          })).catch(errors => {
            self.showErrorMessage = true
            if (errors.response.status === 400) {
              self.errorMessage = errors.response.data.errorMessages[0]
            } else {
              self.errorMessage = errors.message
            }
            self.visitMarkersLoading = false
            self.visitNotesLoading = false
          })
      },
      editItem (item) {
        this.shopMachineVisitDialogMethod = 'edit'
        this.shopMachineVisitId = item.id
        this.showEditDialog = true
      },
      changeEditDialog () {
        this.showEditDialog = false
        this.fetchData()
      },
    },
  }
</script>
